import { commonAdapters } from "src/common-adapters";
import { useSession } from "@user-management-context/primary/hooks/use-session";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import { visibleNotices } from "./notice-banners.helpers";
import { NOTICES, type NoticeTone } from "./notices";

const TONE_CLASSES: Record<NoticeTone, string> = {
  info: "bg-blue-100 text-blue-700 dark:bg-blue-950/50 dark:text-blue-300",
  warning: "bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300",
};

export function NoticeBanners() {
  const { activeRole } = useSession();
  const { dateProvider } = commonAdapters;

  if (!dateProvider) return null;

  return (
    <>
      {visibleNotices(NOTICES, activeRole, dateProvider.now()).map(({ id, title, paragraphs, link, icon: Icon, tone }) => (
        <div key={id} className={cn("flex items-start gap-2 p-4", TONE_CLASSES[tone])}>
          <Icon className="mt-0.5 size-5 shrink-0" />
          <div className="space-y-1 text-sm">
            <p className="font-semibold">{title}</p>
            {paragraphs.map(paragraph => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {link && (
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block font-medium underline underline-offset-2"
              >
                {link.label}
              </a>
            )}
          </div>
        </div>
      ))}
    </>
  );
}
